import React, {Component} from 'react';
import {RootState} from 'store';

export interface Props {
  decline: () => void;
  next: () => void;
  isLast: boolean;
}

export class Announcement extends Component<Props> {
  eligible(state: RootState) {
    return !state.settings.announcements?.[this.constructor.name];
  }

  render() {
    return (
      <div />
    );
  }
}

export function isAnnouncement(fc: any): fc is Announcement {
  return typeof fc === 'function' && fc.prototype instanceof Announcement;
}
